module.exports = __webpack_public_path__ + "img/title1.6bbcb27c.png";